import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { CalendarAppBaseText, defaultBaseText } from './text-interface';

declare const lastDate: string;
declare const pageData: CalendarAppBaseText;

let productionSeasonId: string = (window as any).productionSeasonId || "";
let layoutBreakpoint: string = (window as any).layoutBreakpoint || "1024px";
let promoCode: string = "";
let showShareButtons: boolean = (window as any).showShareButtons == true;
let hasPerformanceInCart: boolean = (window as any).hasPerformanceInCart == true;

let promoCodeData: any = JSON.parse((window as any).promoCode) || "";
let promoCodeDescription = "";
if (promoCodeData?.hasOwnProperty("promoCode")) {
    // Full promo code data
    if (promoCodeData.promoCode?.hasOwnProperty("source")) {
        promoCode = promoCodeData.promoCode.promoCode;
        promoCodeDescription = promoCodeData.promoCode.text2;
    }
    // Just source ID # provided or null
    else {
        promoCode = promoCodeData.promoCode;
    }
}

export interface CalendarBaseSettings extends CalendarAppBaseText {
    lastDate: string,
    promoCode: string,
    promoCodeDescription: string,
    productionSeasonId: string,
    layoutBreakpoint: string,
    showShareButtons: boolean
}

const initialState = {
    ...defaultBaseText,
    lastDate: lastDate || "",
    promoCode: promoCode || "",
    promoCodeDescription: promoCodeDescription,
    productionSeasonId: productionSeasonId,
    layoutBreakpoint: layoutBreakpoint,
    showShareButtons: showShareButtons,
    hasPerformanceInCart: hasPerformanceInCart
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        initializeSettings(state) {
            return {
                ...initialState, ...pageData
            };
        },
        setAppliedPromo(state, action: PayloadAction<string>) {
            state.promoCode = action.payload;
            // This description is only populated on load. If a promo is applied, the description will be returned via the API
            state.promoCodeDescription = "";
        }
    }
});

export const { initializeSettings, setAppliedPromo } = settingsSlice.actions;
export default settingsSlice.reducer;